import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export const eligibleForInsightsSegmentsPipeline = ({ segment, appId }: { appId: c.AppIdType } & c.PipelineSegment) => {
    const id = 'id' in segment ? segment.id : '';

    const segmentParam = 'pipeline' in segment ? segment : id;

    return o.pipeline(
        o.sources.accounts(),
        o.segment(segmentParam),
        o.reduce({
            accountsInSegment: o.count(null),
            numChurned30Day: o.countIf(
                'accountId',
                `metadata.auto_${appId}.lastvisit >= dateAdd(now(), -24, "months") && metadata.auto_${appId}.lastvisit < dateAdd(now(), -30, "days")`,
            ),
            numChurned90Day: o.countIf(
                'accountId',
                `metadata.auto_${appId}.lastvisit >= dateAdd(now(), -24, "months") && metadata.auto_${appId}.lastvisit < dateAdd(now(), -90, "days")`,
            ),
            numActive30Day: o.countIf('accountId', `metadata.auto_${appId}.lastvisit >= dateAdd(now(), -30, "days")`),
            numActive90Day: o.countIf('accountId', `metadata.auto_${appId}.lastvisit >= dateAdd(now(), -90, "days")`),
        }),
    );
};

export function checkInsightsSegmentEligibility ({
    name = 'insights-segment-eligibility',
    segment,
    appId,
}: {
    name?: string;
    segment: c.SimpleSegment | c.SegmentPipeline;
    appId: c.AppIdType;
}) {
    return o.aggregation(
        { name, productArea: PRODUCT_AREAS.INSIGHTS, subProductArea: SUB_PRODUCT_AREAS.INSIGHTS },
        eligibleForInsightsSegmentsPipeline({ segment, appId }),
    );
}

export default {
    name: 'insights-segment-eligibility',
    productArea: PRODUCT_AREAS.INSIGHTS,
    subProductArea: SUB_PRODUCT_AREAS.INSIGHTS,
    build: checkInsightsSegmentEligibility,
};
